var _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShareIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 12.5,
    fill: "#00B0A6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8334 5.5542C15.2809 5.5542 14.751 5.77369 14.3603 6.16439C13.9696 6.55509 13.7501 7.085 13.7501 7.63753C13.7501 8.19007 13.9696 8.71997 14.3603 9.11067C14.751 9.50137 15.2809 9.72087 15.8334 9.72087C16.386 9.72087 16.9159 9.50137 17.3066 9.11067C17.6973 8.71997 17.9168 8.19007 17.9168 7.63753C17.9168 7.085 17.6973 6.55509 17.3066 6.16439C16.9159 5.77369 16.386 5.5542 15.8334 5.5542ZM15.8334 15.2764C15.2809 15.2764 14.751 15.4959 14.3603 15.8866C13.9696 16.2773 13.7501 16.8072 13.7501 17.3598C13.7501 17.9123 13.9696 18.4422 14.3603 18.8329C14.751 19.2236 15.2809 19.4431 15.8334 19.4431C16.386 19.4431 16.9159 19.2236 17.3066 18.8329C17.6973 18.4422 17.9168 17.9123 17.9168 17.3598C17.9168 16.8072 17.6973 16.2773 17.3066 15.8866C16.9159 15.4959 16.386 15.2764 15.8334 15.2764ZM7.50008 10.4153C6.94755 10.4153 6.41764 10.6348 6.02694 11.0255C5.63624 11.4162 5.41675 11.9461 5.41675 12.4986C5.41675 13.0512 5.63624 13.5811 6.02694 13.9718C6.41764 14.3625 6.94755 14.582 7.50008 14.582C8.05262 14.582 8.58252 14.3625 8.97322 13.9718C9.36392 13.5811 9.58342 13.0512 9.58342 12.4986C9.58342 11.9461 9.36392 11.4162 8.97322 11.0255C8.58252 10.6348 8.05262 10.4153 7.50008 10.4153Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8335 17.3599L7.50012 12.4988L15.8335 7.6377",
    stroke: "white",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareIcon);
export default __webpack_public_path__ + "static/media/share-icon.3a672876536a9be5a54ff1e16c7c740a.svg";
export { ForwardRef as ReactComponent };